import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import { sxButtonScheduleAction, sxCloseIconButton, sxTypographySubTitleModal, sxTypographyTitleModal } from './sxProps';


const ModalAtendimentoFinalizado: React.FC<{ showModal: boolean; handleShowModal: () => void; }> = ({ showModal, handleShowModal }) => {

  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/home');
  }

  return (
    <div>
      <Modal
        open={showModal}
        onClose={handleBackToHome}
      >
        <div className='container-finalized-modal' >
          <IconButton
            aria-label="Fechar"
            onClick={handleBackToHome}
            sx={sxCloseIconButton}
          >
            <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
          </IconButton>
          <Typography sx={sxTypographyTitleModal}>Seu atendimento foi finalizado</Typography>
          <Typography sx={sxTypographySubTitleModal}>
            Em breve, você receberá uma pesquisa de satisfação sobre o seu atendimento. Sua opinião é muito importante para nós.
          </Typography>
          <Button variant='contained' sx={sxButtonScheduleAction} onClick={handleBackToHome}>
            <Typography>Voltar para o início</Typography>
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ModalAtendimentoFinalizado;
